import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AffiliateMarketingService {
  private readonly baseUrl = environment.baseUrl;

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar
  ) { }


  getAffiliateSetting(): Observable<any> {
    return this.http.get(`${this.baseUrl}/api/v1/admin/affiliate/setting`)
      .pipe(map((res: any) => res.data));
  }

  postAffiliateSetting(body) {
    return this.http.patch(`${this.baseUrl}/api/v1/admin/affiliate/setting`, { approveList: body })
      .pipe(map(
        (res: any) => {
          if (res.status === 200) {
            this.snackBar.open(res.message, 'Undo', {
              duration: 1000
            })
            return res.data
          } else {
            this.snackBar.open(res.message, 'Undo', {
              duration: 1000
            })
          }
        }
      ));
  }

  getSettingPaymentTime(): Observable<any> {
    return this.http.get(`${this.baseUrl}/api/v1/admin/setting/payment/time`)
      .pipe(map((res: any) => res.data));
  }
  changeDateInSetting(data): Observable<any> {
    return this.http.patch(`${this.baseUrl}/api/v1/admin/setting/payment/time`, data).pipe(map((res: any) => res));

  }
}
